import { Locale } from '@/providers/Locale/types'

type TextFields = 'signupHeading' | 'ctaText' | 'signupDescription' | 'inputPlaceholder' | 'successSubtitle'

export const i18n: Record<Locale, Record<TextFields, string>> = {
    en: {
        signupHeading: 'Sign up for Kinja Deals',
        signupDescription: "Here's your one-stop shop for the best deals of the day. Sign up now for the free newsletter!",
        ctaText: 'Sign me up',
        inputPlaceholder: 'Enter email address',
        successSubtitle: 'Your inbox just got better.',
    },
}
